import { styled } from '@wandb/ui'

export const InlineCode = styled.code`
  padding: ${p => p.theme.spacing(0, 1)};
  background-color: ${p => p.theme.colors.gray[200]};
`
